import { apiClient } from '../../plugins/api'
import {
    MESSAGE_SEND_REQUEST,
    MESSAGE_LIST_REQUEST,
    MESSAGE_THREAD_REQUEST,
    RELOAD_THREAD_REQUEST,
} from '../actions/message'

const state = {
};

const getters = {
};

const actions = {
    async [MESSAGE_SEND_REQUEST] ({ commit }, message) {
        return await apiClient().post('/message/send', message);
    },
    async [MESSAGE_LIST_REQUEST] () {
        const response = await apiClient().get('/message/list');
        return response.data.threads;
    },
    async [MESSAGE_THREAD_REQUEST] ({ commit }, data) {
        const response = await apiClient().get('/message/thread?id=' + data.id);
        return response.data.thread;
    },
    async [RELOAD_THREAD_REQUEST] ({ commit }, data) {
        const response = await apiClient().get('/message/thread?id=' + data.id);
        return response.data.thread.messages;
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
